"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var Cookies = require("js.cookie");
var localStorageUtils_1 = require("../../app/utils/localStorageUtils");
var validatedViewModel_1 = require("./base/validatedViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var workPreferencesPopup_1 = require("./workPreferencesPopup");
var placementsUtils_1 = require("../../app/utils/placementsUtils");
window["Cookies"] = Cookies;
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.isLoading = ko.observable(true);
        this.widgetHtml = ko.observable();
        this.placements = ko.observableArray();
        this.loading = ko.observable(false);
        this.sliderParams = {
            slidesPerView: "auto",
            speed: 300,
            spaceBetween: 8,
            slidesPerGroup: 3,
            grabCursor: true,
            lazyLoading: false,
            scrollbar: ".swiper-scrollbar"
        };
        try {
            var recentlyViewedWorkIds = localStorageUtils_1.default.get(localStorageUtils_1.default.RecentlyViewedKey);
            var $recentlyViewedSlider = $("#recentlyViewedSlider");
            if (!recentlyViewedWorkIds || recentlyViewedWorkIds.length === 0) {
                $recentlyViewedSlider.hide();
            }
            ajaxUtils_1.AjaxUtils.get("work/getByIds", { workIds: recentlyViewedWorkIds, format: options.format })
                .done(function (result) {
                if (!result.isSuccessful) {
                    $recentlyViewedSlider.hide();
                    return;
                }
                var $sliderWrapper = $recentlyViewedSlider.find(".swiper-wrapper");
                $sliderWrapper.removeClass("work-slider-loading");
                $recentlyViewedSlider.addClass("work-slider");
                $sliderWrapper.html(result.data.html);
                app.f7.swiper($recentlyViewedSlider[0], _this.sliderParams);
            }).fail(function () {
                $recentlyViewedSlider.hide();
            });
        }
        catch (ex) {
            console.error(ex);
        }
        app.f7.swiper(".work-slider", this.sliderParams);
        this.refreshRecPanel();
        var $workPreferencesPopup = $("#workPreferencesPopup");
        if ($workPreferencesPopup[0]) {
            this.workPreferencesPopupViewModel = new workPreferencesPopup_1.default(options);
            ko.applyBindings(this.workPreferencesPopupViewModel, $workPreferencesPopup[0]);
        }
        this.initBanners();
        $(document).ready(function () {
            setTimeout(function () {
                if (location.search.indexOf('open-work-preferences-modal=true') != -1) {
                    if (options.authenticated) {
                        app.f7.pickerModal(document.getElementById("workPreferencesPopup"));
                    }
                    else {
                        app.f7.pickerModal(document.getElementById("authWorkPreferencesModal"));
                    }
                }
                _this.showPlacements(options.placementId);
            }, 100);
        });
    }
    ViewModel.prototype.refreshRecPanel = function () {
        var _this = this;
        var $panel = $("#personalRecommendationsPanel");
        this.loading(true);
        var $slider = $panel.find(".swiper-container");
        var $wrapper = $slider.find(".swiper-wrapper");
        if (this.recommendationsSlider) {
            this.recommendationsSlider.destroy(true, true);
            this.recommendationsSlider = null;
        }
        $wrapper.empty();
        ajaxUtils_1.AjaxUtils.get("work/personal-recommendations", {})
            .done(function (result) {
            if (!result.isSuccessful) {
                $panel.hide();
                return;
            }
            $wrapper.html(result.data.html);
            if (!$wrapper.find(".swiper-slide").length) {
                $panel.hide();
                return;
            }
            $panel.show();
            $slider.addClass("work-slider");
            _this.recommendationsSlider = app.f7.swiper($slider[0], _this.sliderParams);
        })
            .fail(function () {
            $panel.hide();
        })
            .always(function () {
            _this.loading(false);
        });
    };
    /** Отображает карусель спонсорского контента */
    ViewModel.prototype.showPlacements = function (placementId) {
        var _this = this;
        this.placementId = placementId;
        this.placements([]);
        if (!placementId)
            return;
        placementsUtils_1.default
            .getPlacements("?id=" + placementId + "&full=false", function (items) {
            _this.placements(items);
            setTimeout(function () {
                app.f7.swiper("#workPlacementSlider", _this.sliderParams);
                placementsUtils_1.default.startViewStatsCollector();
            }, 200);
        });
    };
    /** Скрыть спонсорский контент*/
    ViewModel.prototype.hidePlacements = function () {
        this.placements([]);
        app.f7.closeModal($("#popoverPlacementInfo")[0]);
        placementsUtils_1.default.hidePlacements(this.placementId);
    };
    ViewModel.prototype.showLoginModal = function () {
        app.closePopup();
        app.f7.popup("#loginPopup");
    };
    ViewModel.prototype.initBanners = function () {
        var $banner = $(".mobile-home-banners");
        if ($banner.length) {
            $banner.find(".swipeout-close").on("click", function () {
                Cookies.set($banner.attr("id"), true, { live: 30 });
                $banner.fadeTo('slow', 0).slideUp();
            });
        }
    };
    return ViewModel;
}(validatedViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=homeIndex.js.map